import { ITransaction } from "../../../interfaces";
import { Numeral } from "../../Numeral";

interface WalletTransactionProps {
  transactions: ITransaction[],
  address: string
}
export const WalletTransaction = ({address, transactions}: WalletTransactionProps) => {
  return (
    <>
      {
        transactions && transactions.map((trx: ITransaction, index) => {
          let sign = '';
          if (trx.from === address) {
            sign = '-'
          } else if (trx.to === address) {
            sign = '+'
          }
          return (
            <div key={index}>
              <div className="text-xs d-flex justify-between">
                <div>{`${new Intl.DateTimeFormat('ko-KR').format(new Date(trx.timeStamp * 1000))}`}</div>
                <div className="text-right">{sign} <Numeral value={trx.value * 0.000000000000000001} /></div>
              </div>
            </div>
          )
        })
      }
    </>
  )
}